import { render, staticRenderFns } from "./user_flow_detail_panel.vue?vue&type=template&id=261abe98&scoped=true&lang=pug&"
import script from "./user_flow_detail_panel.vue?vue&type=script&lang=js&"
export * from "./user_flow_detail_panel.vue?vue&type=script&lang=js&"
import style0 from "./user_flow_detail_panel.vue?vue&type=style&index=0&id=261abe98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261abe98",
  null
  
)

export default component.exports